import { render, staticRenderFns } from "./wtSearch2014.component.vue?vue&type=template&id=45edfdfc&"
import script from "./wtSearch2014.component.vue?vue&type=script&lang=js&"
export * from "./wtSearch2014.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports